import React, { useState } from 'react';
import { DashboardPageShell, DashboardPanel } from '../components/dashboard';
import OperatorDashboardHeader from './OperatorDashboardHeader';
import OperatorForkliftDesktopTable from './OperatorForkliftDesktopTable';
import OperatorForkliftMobileCardList from './OperatorForkliftMobileCardList';
import OperatorForkliftToolbar from './OperatorForkliftToolbar';
import './operatorDashboard.css';

export default function OperatorDashboardPage({
  busy,
  filteredForklifts,
  hasMultipleCustomers,
  onRefresh,
  onSafetyReport,
  onSelectForklift,
  onStartChecklist,
  search,
  selectedRowId,
  setSearch,
  title,
}) {
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);

  return (
    <DashboardPageShell
      title={title}
      productDashboardShell="operator"
      renderHeaderActions={({ activeCustomerName, logout, navigate, session }) => (
        <OperatorDashboardHeader
          accountMenuOpen={accountMenuOpen}
          customerName={activeCustomerName}
          logout={logout}
          navigate={navigate}
          onAccountMenuOpenChange={setAccountMenuOpen}
          session={session}
        />
      )}
      headerClassName="operator-dashboard-header"
      contentClassName="operator-dashboard-page"
    >
      <DashboardPanel className="operator-dashboard-panel">
        <OperatorForkliftToolbar
          busy={busy}
          hasMultipleCustomers={hasMultipleCustomers}
          onRefresh={onRefresh}
          search={search}
          setSearch={setSearch}
          shownCount={filteredForklifts.length}
        />

        <div className="operator-forklift-list-area">
          <OperatorForkliftMobileCardList
            busy={busy}
            forklifts={filteredForklifts}
            onSafetyReport={onSafetyReport}
            onSelect={onSelectForklift}
            onStartChecklist={onStartChecklist}
            selectedRowId={selectedRowId}
          />

          <OperatorForkliftDesktopTable
            busy={busy}
            forklifts={filteredForklifts}
            onSafetyReport={onSafetyReport}
            onSelect={onSelectForklift}
            onStartChecklist={onStartChecklist}
            selectedRowId={selectedRowId}
          />
        </div>
      </DashboardPanel>
    </DashboardPageShell>
  );
}
